/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import twitter from "./../assets/images/twitterSec.svg";
import "./Twitter.css";
import { Fade } from "react-reveal";

export default function Twitter() {
  return (
    <div id="twitter">
      <div className="twitterSec container-fluid">
        <Fade bottom>
          <img src={twitter} alt="twitter" />
          <div className="twitterCard">
            <h3>آخر الأخبار</h3>
            <a
              class="twitter-timeline"
              data-lang="ar"
              data-width="400"
              data-height="550"
              data-dnt="true"
              data-theme="dark"
              href="https://twitter.com/valueexperts_OM?ref_src=twsrc%5Etfw"
            >
              Tweets by valueexperts_OM
            </a>
          </div>
        </Fade>
      </div>
    </div>
  );
}
